import { WindowServiceStore } from "./types";
import root from "./modules/root";
import windowTitleBar from "./modules/windowTitleBar";
import main from "./modules/main";
import api from "./modules/api";
import ux from "./modules/ux";
import { createReducer, CreateReducerHook } from "../../../common/redux";
import Logger from "../../../clients/logger";
import { createRemoteReduxStore } from "../common/store";

const windowTitleBarInitialState = windowTitleBar.getInitialState();
const rootInitialState = root.getInitialState();
const mainInitialState = main.getInitialState();
const apiInitialState = api.getInitialState();
const uxInitialState = ux.getInitialState();

/**
 * Each module should export its bit of initial state. Note that we're not using redux slices because
 * those prevent state changes across slices of state. Our modules are allowed to cross state, though it should still
 * be avoided if at all possible because of the risk of race conditions.
 */
export const initialState: WindowServiceStore = {
	root: rootInitialState,
	windowTitleBar: windowTitleBarInitialState,
	main: mainInitialState,
	api: apiInitialState,
	ux: uxInitialState,
	finsembleConfig: {},
};

const loggerHook: CreateReducerHook = (previousState, nextState, action) => {
	Logger.system.debug("forceObjectsToLogger", `WindowStore.${action.type}`, nextState, action);
};

/**
 * This is our proprietary createReducer() derived from RTK's version. See createReducer.ts for docs.
 */
export const getReducer = () =>
	createReducer(
		initialState,
		(builder) => {
			root.addReducerCases(builder);
			windowTitleBar.addReducerCases(builder);
			main.addReducerCases(builder);
			api.addReducerCases(builder);
			ux.addReducerCases(builder);
		},
		loggerHook
	);

/**
 * Lazily creates the store.
 */
export const getStore = () =>
	createRemoteReduxStore("@@finsemble/remoteRedux/WindowServiceStore", initialState, getReducer);
